import React, { useCallback, useEffect, useState } from 'react';

export default ({ panel, setting, updatePanel, className, title }) => {
  const [options, setOptions] = useState(null);

  const loadOptions = useCallback(async () => {
    setOptions(await setting.options());
  }, [setting]);
  useEffect(() => {
    loadOptions();
  }, [loadOptions]);

  if (!options) {
    return (
      <select disabled>
        <option>Loading options…</option>
      </select>
    );
  }

  return (
    <>
      <div className={className}>{title}</div>
      <select
        value={panel.getIn(['settings', setting.key])}
        onChange={event => {
          let updatedPanel = panel.setIn(
            ['settings', setting.key],
            event.target.value
          );

          if (setting.updateTitle) {
            const option = options.find(
              option => String(option.value) === event.target.value
            );
            updatedPanel = updatedPanel.set('name', option.text);
          }

          updatePanel(updatedPanel);
        }}
      >
        <option>Choose an option</option>
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.text || option.value}
          </option>
        ))}
      </select>
    </>
  );
};
